import { BE_DEFINES } from 'constants/backend-defines.const';
import { I18nNamespace } from 'constants/i18n.const';
import {
  DEFAULT_SHEET_OF_FRAME,
  DEFAULT_SHEET_OF_FRAME_6X20,
  FRAME_4X6_ID,
  FRAME_6X20_ID,
  FRAME_CARD_ID,
  INIT_THEME_DETAIL_ID,
  LAYOUT_IDOL_ID,
} from 'constants/photo.const';
import { useSoundContext } from 'context/SoundContext';
import { isEqualVal } from 'helpers/string.helper';
import { useModal } from 'hooks/useModal';
import { useNewPhotoLifeCycleStep } from 'hooks/useNewPhotoLifeCycleStep';
import { LayoutPhotoModel } from 'models/photo/layout.model';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { setSelfeAppStateAction } from 'store/features/app/selfeAppSlice';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';

export function useLayoutActions() {
  const { t } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const { openConfirmModal, closeConfirmModal } = useModal();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { audio } = useSoundContext();
  const { getNextPath } = useNewPhotoLifeCycleStep();
  const { isThemeBeforePayment, boothInfo, isEventBooth } = useAppSelector(
    (s) => s.booth,
  );

  const handleSelectLayout = useCallback(
    (
        layoutId: number | undefined,
        themeDetailId: number | undefined,
        layout?: LayoutPhotoModel,
      ) =>
      async () => {
        const performAction = async () => {
          await dispatch(
            setSelfeAppStateAction({
              layoutId,
              themeDetailId: isThemeBeforePayment
                ? themeDetailId
                : INIT_THEME_DETAIL_ID,
              ...(isEventBooth && {
                quantityPicOfPerSheet: layout?.numberOfPicture,
                frameId: layout?.frameId,
                quantitySheet:
                  isEqualVal(layout?.frameId, FRAME_6X20_ID) ||
                  isEqualVal(layout?.frameId, FRAME_CARD_ID) ||
                  (boothInfo?.IsLayout820 &&
                    isEqualVal(layout?.frameId, FRAME_4X6_ID)) ||
                  (isEventBooth && isEqualVal(layout?.frameId, FRAME_4X6_ID))
                    ? DEFAULT_SHEET_OF_FRAME_6X20
                    : DEFAULT_SHEET_OF_FRAME,
              }),
            }),
          );
          audio?.playClickToSelect?.();
          navigate(getNextPath() || '');
        };
        if (layoutId === LAYOUT_IDOL_ID) {
          openConfirmModal({
            content: t('alertpopuplayoutidol'),
            onOk: async () => {
              closeConfirmModal();
              await performAction();
            },
          });
        } else {
          await performAction();
        }
      },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, getNextPath, isThemeBeforePayment, navigate, t],
  );

  return {
    handleSelectLayout,
  };
}
